import React from 'react';
import MainFrame from './MainFrame';
import RedirectPage from './components/RedirectPage';
import PaymentFail from './components/PaymentFail';
import PaymentSuccess from './components/PaymentSuccess';
import PaygateLaunch from './components/PaygateLaunch';

function App() {
  
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let qparms = {};
  let showError = false;
  qparms.operation = params.get('op');
  qparms.logo = params.get('lg');

  if (!qparms.operation){
    showError=true
  } else {
    switch (qparms.operation) {

      case 'register':
        qparms.inst = params.get('inst');
        qparms.fid = params.get('fid');
        qparms.pid = params.get('pid');
        if (!qparms.fid||!qparms.inst){showError=true}
      break;
      
      case 'apply':
        qparms.inst = params.get('inst');
        qparms.fid = params.get('fid');
        qparms.pid = params.get('pid');
        if (!qparms.fid||!qparms.inst){showError=true}
      break;
      
      case 'otp_link':
        qparms.token = params.get('token');
        if (!qparms.token){showError=true}
      break;

      case 'redirect':
        qparms.token = params.get('token');
        qparms.entry = params.get('entry');
      break;

      case 'paygate_launch':
        qparms.token = params.get('token');
        qparms.entry = params.get('entry');
        qparms.item_name = params.get('item_name');
        qparms.amount = params.get('amount');
        qparms.email_address = params.get('email_address');
        qparms.receiver = params.get('receiver');
      break;

      default:
        const paygate_flag = qparms.operation.charAt(0);
        if ((!paygate_flag==="S"&&!paygate_flag==="F")||qparms.operation.search("~")<4||qparms.operation.search("~")>12){
          showError=true;
        } else {
          qparms.paygate_return = true;
          qparms.paygate_result = paygate_flag==="S"? "Success" : "Fail";
          qparms.entry = qparms.operation.substring(1,qparms.operation.search("~"));
          qparms.token = qparms.operation.substring(qparms.operation.search("~")+1,qparms.operation.length);
          // console.log('qparms.paygate_return :>> ', qparms.paygate_return);
          // console.log('qparms.paygate_result :>> ', qparms.paygate_result);
          // console.log('qparms.entry :>> ', qparms.entry);
          // console.log('qparms.token :>> ', qparms.token);
        }
      break;
    }
  }

  return (
    <div className="App">
        
      {!showError&&
      <div>
        {qparms.operation!=='redirect'&&!qparms.paygate_return&&qparms.operation!=='paygate_launch'&&
        <MainFrame qparms={qparms} otp_link={qparms.operation==='otp_link'? true : false} />}

        {qparms.operation==='redirect'&&!qparms.paygate_return&&
        <RedirectPage qparms={qparms}/>}

        {qparms.operation==='paygate_launch'&&
        <PaygateLaunch qparms={qparms} />}

        {qparms.paygate_return&&qparms.paygate_result==="Fail"&&
        <PaymentFail qparms={qparms}/>}

        {qparms.paygate_return&&qparms.paygate_result==="Success"&&
        <PaymentSuccess qparms={qparms}/>}

      </div>}

      {showError&&
      <div style={{maxWidth:800}}>
        <h3>Invalid Link</h3>
        The requested Prime-Entry link or address is invalid - please ensure you follow the original link to the desired application form.<br/>
        If this problem persists, please contact us.
      </div>}

    </div>
  );
}

export default App;
